import { createElement, styled, composedProps } from '@vebox/etui-system';

const H5Element = createElement('h5');
const H5 = styled(H5Element)(composedProps);

export { H5 };
